<!-- START HEADER-->
<header class="header" app-klm-header></header>
<!-- END HEADER-->

<!-- START SIDEBAR-->
<nav class="page-sidebar" id="sidebar" app-klm-sidebar></nav>
<!-- END SIDEBAR-->

<!-- START PAGE CONTENT-->
<div class="content-wrapper">
    <router-outlet></router-outlet>
    <!-- <div app-banner></div> -->
    <footer class="page-footer" app-klm-footer></footer>
</div>

